import { Rokojori } from "../../Rokojori";
import { AudioEditor } from "../audio-editor/AudioEditor";

export class RokojoriApps
{
  static applyOnDocument( rokojori:Rokojori )
  {
    AudioEditor.applyOnDocument( rokojori )
    
  }
}